import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import classNames from "classnames";
import { ReactNode } from "react";
import { Option } from "../../types";
import styles from "./style.module.scss";

interface SelectPillProps<T extends string = string> {
  options: Option<T>[];
  value: T;
  onChange: (key: T) => void;
  /** Leading glyph, e.g. a tune or filter icon. */
  icon?: ReactNode;
  ariaLabel?: string;
  className?: string;
}

/**
 * Tinted pill-shaped native select. Native on purpose: it keeps the mobile
 * picker and keyboard behaviour without dragging in a popover.
 */
function SelectPill<T extends string = string>({
  options,
  value,
  onChange,
  icon,
  ariaLabel,
  className,
}: SelectPillProps<T>) {
  return (
    <div className={classNames(styles.wrap, className)}>
      {icon && <span className={styles.leading}>{icon}</span>}
      <select
        aria-label={ariaLabel}
        value={value}
        onChange={(event) => onChange(event.target.value as T)}
        className={classNames(styles.select, !icon && styles.noLeading)}
      >
        {options.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
      <ExpandMoreIcon className={styles.chevron} />
    </div>
  );
}

export default SelectPill;
